export default __webpack_public_path__ + "static/media/ep3collage1.b681fa55.jpg";